<template>
  <v-row class="ma-5">
    <v-col
      cols="6"
      md="3"
      class="card text-center"
      v-for="(res, i) in partnersToUse"
      :key="i"
    >
      <v-card @click="$emit('openOrdera', res)" class="partner-card">
        <img
          class="card-img-top partner-card-img"
          width="100%"
          height="75%"
          :src="
            res.settings?.logo
              ? `https://app.restorani.bitlab.host/gallery/${res.id}/${res.settings.logo}`
              : './media/img/pexels-lumn-1410235.jpg'
          "
          alt="Logo"
        />
        <div class="card-body">
          <h5 class="text-h6">{{ toLatin(res.name) }}</h5>
          <p class="text-body-2 pb-4">
            <span>{{ toLatin(res.city?.name || "") }}</span>
          </p>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PartnerCards",
  props: {
    partners: Array,
  },
  computed: {
    ...mapState("companyMenu", ["partners"]),
    partnersToUse() {
      return this.partners || this.partners;
    },
  },
};
</script>

<style scoped>
.partner-card {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.partner-card-img {
  cursor: pointer;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
</style>
